import "./LocationSelector/locationheader.scss";
import * as React from "react";
import { connect, type ConnectedProps } from "react-redux";
import { stopLoading } from "../../Actions/General/LayoutActions";
import { changeRegister } from "../../Actions/General/LocationActions";
import PopupManager from "../../Common/Popups/PopupManager";
import { withPermissions } from "../../Utilities/Domain/Users/Permissions";
import FontAwesomeLight from "../../Utilities/Platform/FontAwesome/FontAwesomeLight";
import CurrentLocation from "./LocationSelector/CurrentLocation";

const connector = connect();

type PropsFromRedux = ConnectedProps<typeof connector>;

interface Props extends PropsFromRedux {
    permissions: {
        change_register: boolean;
    };
}

export class LocationHeader extends React.Component<Props> {
    public state = {
        current: false,
    };

    public handleMouseOver = (): void => {
        this.setState({
            current: true,
        });
    };

    public handleMouseOut = (): void => {
        this.setState({
            current: false,
        });
    };

    public handleClick = (): void => {
        if(!this.props.permissions.change_register) {
            PopupManager.info("You don't have permission to change the current location");

            return;
        }

        this.props.dispatch(stopLoading());
        this.props.dispatch(changeRegister());
    };

    public render(): React.ReactNode {
        let current: React.ReactNode = null;

        if(this.state.current) {
            current = <CurrentLocation />;
        }

        return (
            <div
                className="header-item"
                id="location-header"
                onClick={this.handleClick}
                data-testid="sh-location-selector"
            >
                <FontAwesomeLight
                    icon="map-signs"
                    onMouseOver={this.handleMouseOver}
                    onMouseOut={this.handleMouseOut}
                />
                {current}
            </div>
        );
    }
}

export default connector(withPermissions(LocationHeader, [
    "change_register",
]));
